import React from 'react';

import WsIconProps from './IconProps';

const Summary: React.FC<WsIconProps> = ({ color = '#616893', width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 5L15.586 2.586C15.211 2.2109 14.7024 2.00011 14.172 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.379 12.6261C21.7773 12.2278 22.0011 11.6875 22.0011 11.1241C22.0011 10.5608 21.7773 10.0205 21.379 9.62215C20.9806 9.22379 20.4403 9 19.877 9C19.3136 9 18.7733 9.22379 18.375 9.62215L14.365 13.6341C14.1272 13.8718 13.9532 14.1655 13.859 14.4881L13.022 17.3581C12.9969 17.4442 12.9954 17.5354 13.0176 17.6222C13.0398 17.7091 13.085 17.7883 13.1484 17.8517C13.2118 17.9151 13.291 17.9603 13.3779 17.9825C13.4647 18.0048 13.5559 18.0032 13.642 17.9781L16.512 17.1411C16.8346 17.0469 17.1283 16.8729 17.366 16.6351L21.379 12.6261Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8 18H9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Summary;
